import { render, staticRenderFns } from "./totalModal.vue?vue&type=template&id=627a39f2&scoped=true"
import script from "./totalModal.vue?vue&type=script&lang=js"
export * from "./totalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627a39f2",
  null
  
)

export default component.exports